import styled, { keyframes } from 'styled-components'
import { slideInUp } from 'react-animations'

const animateEntry = keyframes`${slideInUp}`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const AnimateEntry = styled.div`
  animation: ${props => `0.8s ${animateEntry}`};
`



// WEBPACK FOOTER //
// ./src/component/MyDashboard/MyDashboard-styled.js